<!--
 * @Author: MoBai
 * @Date: 2022-02-09 09:56:04
 * @LastEditTime: 2022-02-09 09:57:49
-->
<template>
  <div>
    <el-table :data="tableList" style="width: 100%; margin-top: 32px">
      <el-table-column label="序号" align="center" width="100%">
        <template slot-scope="scope">
          <div class="indexStyle">
            <span class="item"> {{ scope.$index + 1 }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="活动名称" width="200px">
        <template slot-scope="scope">
          <div class="hiddenName">
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="浏览量">
        <template slot-scope="scope">
          <div>
            {{ scope.row.pageViewsNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="报名人数">
        <template slot-scope="scope">
          <div>
            {{ scope.row.enrollment }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>
            {{ scope.row.data || '-' }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="table-page">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :current-page.sync="pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[5, 10]"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LsAuditorium',
  data() {
    return {
      tableList: [
        {
          name: '丽水市遂昌县工业园区',
          enrollment: 20,
          pageViewsNum: 90,
          data: '2021-01-01'
        },
        {
          name: '丽水市遂昌县工业园区',
          enrollment: 20,
          pageViewsNum: 90,
          data: '2021-01-01'
        },
        {
          name: '丽水市遂昌县工业园区',
          enrollment: 20,
          pageViewsNum: 90,
          data: '2021-01-01'
        },
        {
          name: '丽水市遂昌县工业园区',
          enrollment: 20,
          pageViewsNum: 90,
          data: '2021-01-01'
        },
        {
          name: '丽水市遂昌县工业园区',
          enrollment: 20,
          pageViewsNum: 90,
          data: '2021-01-01'
        }
      ],
      pageNum: 1,
      pageSize: 5,
      totalRecord: 5
    }
  },
  methods: {
    handleCurrentChange() {},
    handleSizeChange() {}
  }
}
</script>

<style lang="scss" scoped>
@import './style/common.scss';

.indexStyle {
  width: 100%;
  .item {
    display: inline-block;
    width: 0.3rem;
    height: 0.3rem;
    line-height: 0.3rem;
    border-radius: 50%;
    box-shadow: inset 0 0 0.08rem 0 rgba(18, 254, 253, 1);
  }
}
.hiddenName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
